/*
 * @Author: Soul
 * @Date: 2021-05-31 17:23:14
 * @LastEditors  : Soul
 * @LastEditTime : 2021-05-31 17:23:14
 * @Description: file content
 */
export default {
  env: {
    // actId: 200
    // platformId: 121
    // appId: wx8c7f4ce9b0b1ad4f
    // 域名: web.homtop.cn
    // 备用域名: web.ruthfckj.com
    prod: {
      site: {
        appid: "wx89278dce41c7aab1",
        protocol: "http:",
        domain: "web.homtop.cn",
      },
      routersActWxauth: {
        fake: {
          hope: {
            // actOpenId: 'oHbpVwV-gyUF5o5H5D7-gTKWOruk',
            actOpenId: 'oHbpVwdkI9BNq--BfVwGLmAkVRFM',
            actAppId: 'wx89278dce41c7aab1',
          }
        }
      },
      servicesActWxjssdk: {
        appid: 'wx89278dce41c7aab1',
      },
      apiActWxauth: {
        appid: "wx89278dce41c7aab1",
        protocol: "http:",
        domain: "web.homtop.cn"
      },
      apiActLogicPlatform: {
        protocol: "http:",
        domain: "web.homtop.cn",
      },
      apiActLogicChenda: {
        protocol: "https:",
        domain: "actapi2.ttrsznkj.com",
      },
      httpActLogicChenda: {
        actCode: "jnfive2020",
        actEndMsg: "活动已结束，感谢您的参与，兑奖地址请点击玩法介绍—我的奖品"
      },
      apiActLogicDengfan: {
        protocol: "https:",
        domain: "actapi2.ttrsznkj.com",
      },
      httpActLogicDengfan: {
        appId: "wx89278dce41c7aab1",
        actId: 578,
        token: 'b16f854daa550780339aea4a0eabab08' //核销奖品所需要的token
      }
    },
  },
  APPID: 'wx89278dce41c7aab1',
  audioSrc: 'https://assets.rurushishi.com/activies/football/aoduohuayuan.mp3', //背景音乐 格式mp3 大小1M以内
  actId: 578,
  platformId: 121,
  apiHost: '/common-jifen/oop/',
  imgHost: 'https://assets.rurushishi.com/activies/football/',
  company: '澳朵花园'
};